
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 28">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.882 2.03964L17.121 2.04594H24.2014V27.71H0L0.0063049 2.03964H8.31616V0H15.882V2.03964ZM9.57715 3.30062H7.37043V4.76966H16.8278V3.30062H15.8757L14.6211 3.29431V1.26098H9.57715V3.30062ZM22.7071 26.2158H1.49741L1.50372 3.5339H6.10945V6.03064H18.0888V3.5402H22.7071V26.2158ZM7.86537 13.6249V10.9201H5.16056V13.6249H7.86537ZM9.12634 9.65911H3.89958V14.8859H9.12634V9.65911ZM7.86537 21.5344V18.8296H5.16056V21.5344H7.86537ZM9.12634 17.5686H3.89958V22.7954H9.12634V17.5686ZM11.5569 9.69063H20.3049V10.9516H11.5569V9.69063ZM20.3049 15.6015H11.5569V16.8625H20.3049V15.6015ZM11.5569 21.5123H20.3049V22.7733H11.5569V21.5123Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Ordered',
    }) as DefineComponent
    </script>
    